import { render } from "./AutomaticReportCard.vue?vue&type=template&id=3f884539"
import script from "./AutomaticReportCard.vue?vue&type=script&lang=js"
export * from "./AutomaticReportCard.vue?vue&type=script&lang=js"

import "./AutomaticReportCard.vue?vue&type=style&index=0&id=3f884539&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSeparator,QIcon,QCardActions,QBtn});
